import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// telerik imports
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LayoutModule, GridLayoutModule, TabStripModule } from '@progress/kendo-angular-layout';
import { TextBoxModule, TextAreaModule, CheckBoxModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { BreadCrumbModule } from '@progress/kendo-angular-navigation';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { NotificationModule } from '@progress/kendo-angular-notification';

import { SharedModule } from '@shared/shared.module';
import { HttpClient } from '@angular/common/http';

import { AuthenticationService } from '@core/services/authentication.serivce';

import { SelectFieldComponent } from '../../shared/components/select-field/select-field.component';
import { MoneyFieldComponent } from '../../shared/components/money-field/money-field.component';
import { DetailComponent } from '../../shared/components/detail/detail.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { FulfillmentOrderComponent } from './fulfillment-order/fulfillment-order.component';
import { FulfillmentOrdersRoutingModule } from './fulfillment-orders.routing.module';


@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    LayoutModule,
    TextBoxModule,
    TextAreaModule,
    CheckBoxModule,
    DatePickerModule,
    LabelModule,
    GridLayoutModule,
    GridModule,
    DropDownsModule,
    IconsModule,
    NotificationModule,
    DialogModule,
    InputsModule,
    SharedModule,
    TabStripModule,
    LoaderModule,
    FulfillmentOrdersRoutingModule,
    SelectFieldComponent,
    MoneyFieldComponent,
    FaIconComponent,
    DetailComponent,
    SearchComponent,
  ],
  declarations: [
    FulfillmentOrderComponent
  ],
  providers: [AuthenticationService]
})
export class FulfillmentOrdersModule { }
